import React, {useContext, useEffect, useState} from 'react';
import {IDepotSummary} from '../../Foundations/Types/IDepot';
import CircleMapMarker from './CircleMapMarker';
import ArrowRight from '../../Components/Icons/ArrowRight';
import SvgIcon from '../../Components/Icons/SvgIcon';
import resultsContext from '../../Foundations/Contexts/ResultsContext';
import {getSupplierName} from '../../Foundations/Utils/SupplierUtils';

interface IProps {
    marker: IDepotSummary,
    lat: number,
    lng: number
}

export const renderTriangle = () => (
    <span style={{ left: 'calc(50% - 12px)', bottom: '-7px'}}
          className="bg-white z-0 transform rotate-45 h-4 w-4 inline-block absolute border-b border-r border-gray-400"
    />
)

const DepotMapMarker: React.FC<IProps> = ({ marker, lat, lng }) => {
    const { selectedItem } = useContext(resultsContext);
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const markerWidth: number = 200;
    const markerLeft: number = -(markerWidth/2);
    const markerTop: number = -40;
    const markerRadius: number = 32;

    useEffect(() => {
        if (selectedItem !== null) {
            setIsExpanded(
                selectedItem.supplier_code === marker.supplier_code &&
                selectedItem.depot_coordinates.x === marker.depot_coordinates.x &&
                selectedItem.depot_coordinates.y === marker.depot_coordinates.y
            );
        }
    }, [selectedItem, marker])

    return (
        <div style={{ width: `${markerWidth}px`, left: `${markerLeft}px`, top: `${markerTop}px`, zIndex: `${isExpanded ? '60' : '40'}`}}
             className="relative text-center">
            {
                isExpanded === false &&
                marker.lowestPerDay !== null &&
                marker.highestPerDay !== null &&
                <div onClick={() => setIsExpanded(true)}
                    className="relative z-10 inline-block font-bold p-2 shadow shadow-2xl rounded text-center bg-white border border-gray-400">
                    <span className="relative z-10 text-gray-700">${marker.lowestPerDay.per_day_price} - ${marker.highestPerDay.per_day_price}</span>
                    {renderTriangle()}
                </div>
            }
            {
                isExpanded === true &&
                <div className="flex justify-center relative z-30">
                    <div style={{ left: `${markerRadius/8}px`}}
                        className="bg-white absolute p-2 rounded shadow shadow-2xl bottom-full min-w-full text-left">
                        <p className="text-gray-700 text-sm">
                            <strong>{marker.supplier_name || getSupplierName(marker.supplier_code)} ({marker.depot_code})</strong><br />
                            {marker.address}
                        </p>
                        {
                            typeof marker.distance !== 'undefined' &&
                            <span className="font-bold text-green text-xs block my-2">
                                {marker.distance.toFixed(2)}km from location
                            </span>
                        }
                        {
                            marker.lowestPerDay !== null &&
                            marker.highestPerDay !== null &&
                            (
                                selectedItem === null ||
                                (
                                    selectedItem.supplier_code !== marker.supplier_code &&
                                    selectedItem.depot_coordinates.x !== marker.depot_coordinates.x &&
                                    selectedItem.depot_coordinates.y !== marker.depot_coordinates.y
                                )
                            ) &&
                            (
                                <div className="mt-2 text-gray-700 font-bold text-base flex items-center">
                                    <span>
                                        ${marker.lowestPerDay.per_day_price}
                                    </span>
                                            <SvgIcon height="18" className="fill-gray-700 inline-block mx-2">
                                                <ArrowRight />
                                            </SvgIcon>
                                            <span>
                                        ${marker.highestPerDay.per_day_price}
                                    </span>
                                </div>
                            )
                        }
                        {
                            selectedItem !== null &&
                            selectedItem.supplier_code === marker.supplier_code &&
                            selectedItem.depot_coordinates.x === marker.depot_coordinates.x &&
                            selectedItem.depot_coordinates.y === marker.depot_coordinates.y  &&
                            (
                                <div className="mt-2 text-gray-700 text-base items-center">
                                    <span className="block font-bold">${selectedItem.per_day_price}</span>
                                    <span className="text-sm">{selectedItem.vehicle_data.name}</span>
                                </div>
                            )
                        }
                        {renderTriangle()}
                    </div>
                    <div className="relative" style={{ top: `${markerRadius}px`}}>
                        <CircleMapMarker
                            onClick={() => setIsExpanded(false)}
                            className="bg-blue-600"
                            lat={lat}
                            lng={lng}
                            height={markerRadius}
                            width={markerRadius}
                        />
                    </div>
                </div>
            }
        </div>
    )
}

export default DepotMapMarker;
